export default __webpack_public_path__ + "static/media/JD.11c75ebf.jpg";